/**
 * Converts a product title (Persian or English) into a URL-friendly slug.
 * Persian characters are kept as-is (valid in URLs and beneficial for SEO).
 * Spaces become hyphens; punctuation and special characters are removed.
 */
export function slugify(text: string): string {
  return text
    .trim()
    .replace(/\s+/g, '-')
    .replace(/[^\u0600-\u06FFa-zA-Z0-9-]/g, '')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')
}
